/**
 * MessageDisplay.js
 *
 * A component for displaying temporary messages to users, such as:
 * - Success messages
 * - Error messages
 * - Warning messages
 * - Information messages
 *
 * Features:
 * - Auto-dismissing after 5 seconds
 * - Positioned at bottom-right of screen
 * - Different severity levels (error, warning, info, success)
 * - Manual dismissal option
 */

import React from "react";
import { Alert, Snackbar } from "@mui/material";

/**
 * MessageDisplay Component
 *
 * Displays a temporary message in a snackbar at the bottom-right of the screen.
 *
 * @param {Object} props - Component properties
 * @param {string} props.message - The message text to display
 * @param {string} props.severity - Message type ('error', 'warning', 'info', 'success')
 * @param {boolean} props.open - Whether the message should be visible
 * @param {Function} props.onClose - Handler for when the message is closed
 */
const MessageDisplay = ({ message, severity, open, onClose }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageDisplay;
